import type { ZxcvbnScore } from '@nest-react/domain';
import type { ReactElement } from 'react';

const SCORE_COLOR: Record<ZxcvbnScore, string> = {
  0: 'bg-red-400',
  1: 'bg-orange-400',
  2: 'bg-amber-400',
  3: 'bg-yellow-400',
  4: 'bg-emerald-400',
};

export const PasswordStrengthIndicator = ({
  score,
  label,
}: {
  score: ZxcvbnScore;
  label: string;
}): ReactElement => {
  const activeSegments = score + 1;
  const colorClass = SCORE_COLOR[score];

  return (
    <div className="grid gap-1.5">
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map(segment => (
          <div
            key={segment}
            className={`h-1 flex-1 rounded-full transition-colors ${
              segment < activeSegments ? colorClass : 'bg-border-subtle'
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-subtle">{label}</p>
    </div>
  );
};
